import { render, staticRenderFns } from "./Novo-Outras-Entrada.vue?vue&type=template&id=4136806d&scoped=true&"
import script from "./Novo-Outras-Entrada.vue?vue&type=script&lang=js&"
export * from "./Novo-Outras-Entrada.vue?vue&type=script&lang=js&"
import style0 from "./Novo-Outras-Entrada.vue?vue&type=style&index=0&id=4136806d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4136806d",
  null
  
)

export default component.exports